import React from 'react';
import { Table } from 'react-bootstrap';
import axios from './../../../constants/axios';
import { Link } from 'react-router';

class ChartOfAccountHome extends React.Component {

   constructor(props) {
      super(props);
      this.state = {
         chartOfAccounts: []
      };
   }

   componentDidMount() {
      axios.get('accounting/chartOfAccounts')
         .then((res) => {
            this.setState({
               chartOfAccounts: res.data
            });
         });
   }

   render() {
      const { chartOfAccounts } = this.state;
      return (
         <Table striped bordered condensed hover >
            <thead>
            <tr>
               <th>Account Id</th>
               <th>Name</th>
               <th>Type</th>
               <th>Actions</th>
            </tr>
            </thead>
            <tbody>

            {chartOfAccounts.map((account) => (
               <tr key={account.id} >
                  <td>{account.id}</td>
                  <td>{account.name}</td>
                  <td>{account.chart_of_account_type_name}</td>
                  <td>
                     <Link to={`/account/edit/${account.id}`} >edit</Link>
                  </td>
               </tr>
            ))}
            </tbody>
         </Table>
      );
   }
}

ChartOfAccountHome.propTypes = {};

export default ChartOfAccountHome;



/** WEBPACK FOOTER **
 ** ./src/components/AccountingManagement/ChartOfAccount/ChartOfAccountHome.js
 **/